/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Replicate_DescriptionInputs */

const en_admin_settings_groups_replicate_description = /** @type {(inputs: Admin_Settings_Groups_Replicate_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replicate AI API`)
};

/**
* | output |
* | --- |
* | "Replicate AI API" |
*
* @param {Admin_Settings_Groups_Replicate_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_replicate_description = /** @type {((inputs?: Admin_Settings_Groups_Replicate_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Replicate_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_groups_replicate_description(inputs)
});
export { admin_settings_groups_replicate_description as "admin.settings.groups.replicate.description" }